export const es = {
  // Common
  conversation: 'Conversación',
  connected: 'Conectado',
  disconnected: 'Desconectado',
  loading: 'Cargando...',
  error: 'Error',
  
  // Welcome messages
  welcomeMessage: 'Hola, ¿cómo puedo ayudarte hoy?',
  joinedChat: 'se unió al chat',
  
  // Chat actions
  createNewChat: 'Crear una nueva conversación',
  newConversation: 'Nueva conversación',
  moreResults: 'Quiero más resultados',
  
  // Input placeholders
  inputPlaceholder: 'Escribe un mensaje...',
  inputPlaceholderGenerating: 'Generando resultados...',
  
  // Loading messages
  collectingInfo: 'Recolectando información necesaria ...',
  searchingBestResults: 'Buscando los mejores resultados ...',
  analyzingDatabase: 'Analizando base de datos para búsqueda ...',
  checkingSpecialOffers: 'Verificando ofertas especiales disponibles ...',
  searchingSimilarProducts: 'Buscando productos similares ...',
  preparingRecommendations: 'Preparando recomendaciones personalizadas ...',
  checkingStock: 'Verificando stock y disponibilidad de productos ...',
  finalizingResponse: 'Finalizando respuesta con las opciones más relevantes ...',
  
  // Thinking steps
  analyzingRequest: 'Analizando tu solicitud ...',
  generatingSearchTerms: 'Generando términos de búsqueda ...',
  processingSearchTerms: 'Procesando términos de búsqueda ...',
  searchingDatabase: 'Buscando en la base de datos productos adecuados ...',
  processingResults: 'Procesando resultados encontrados ...',
  generatingEstimates: 'Generando estimaciones de tiempo y costo ...',
  generatingFinalResponse: 'Generando respuesta final ...',
  processingRequest: 'Findly está pensando ...',
  
  // Status messages
  waitingPreviousResults: 'Esperando resultados de conversación anterior ...',
  checkingContinuation: 'Verificando si la conversación puede continuar...',
  
  // Empty states
  noMessagesYet: 'Aún no hay mensajes',
  
  // Error messages
  failedCreateChat: 'Error al crear un nuevo chat. Por favor, inténtalo de nuevo.',
  errorCreatingChat: 'Error al crear el chat',
  errorSendingMessage: 'Error al enviar mensaje',
  errorLoadingChats: 'Error al cargar chats',
  
  // Cart messages
  productAddedToCart: '¡El producto {{productCode}} ha sido añadido al carrito!',
  
  // Chat titles
  defaultChatTitle: 'Chat {{timestamp}}',
  
  // Connection status
  connectionStatusConnected: 'Conectado 🟢',
  connectionStatusDisconnected: 'Desconectado 🔴',

  // Chat encouragement messages (cycled every 5 seconds)
  chatEncouragement1: '¡Puedo ayudarte a encontrar los productos que buscas!',
  chatEncouragement2: '¿Necesitas ayuda para encontrar algo específico?',
  chatEncouragement3: '¡Déjame ayudarte con tus compras!'
};
